import React, { memo } from "react";
import { Link, LinkProps } from "@mui/material";

const CustomLink = memo((props: LinkProps) => {
  return <Link {...props} />;
});

export { CustomLink };
